import useMeQuery from '@hooks/queries/useMeQuery';
import useAuthStore from '@src/stores/authStore';

export default function useCurrentResidenceJoinCodeQuery(options) {
  const { residenceId } = useAuthStore();

  return useMeQuery({
    select: (user) => {
      const r = user?.residences?.find((res) => res.id === residenceId);
      return r?.join_code ?? r?.joinCode ?? null;
    },
    ...options,
  });
}
